export const DASHBOARD_URL = "/dashboard";
export const HOME_URL = "/";
export const LOGIN_URL = "/login";
export const LOGOUT_URL = "/logout";
export const NOT_FOUND_URL = "/notfound";
export const SILENT_RENEW_CALLBACK_URL = "/silentrenewcallback";
